// features/invite/invite.service.ts
import { LOCALES } from '../../../common/constants';
import { post, get } from '../../api/api.service';

export interface InvitePayload {
  emails: string[];
}

export const submitInviteApi = async (emails: string[], lang: string = 'en-us') => {
  try {
    const response = await post(`/freelancer/invite-multiple?language=${lang}`, emails);
    return response;
  } catch (error: any) {
    // Handle axios error and extract meaningful error message
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      if (errorData.message) {
        throw new Error(errorData.message);
      } else if (typeof errorData === 'string') {
        throw new Error(errorData);
      }
    }
    
    // Fallback to original error message
    throw new Error(error.message || 'Failed to send invitations');
  }
};// features/invite/invite.service.ts


export interface InviteEmailData {
  statusCode: number;
  message: string;
  response?: any;
}

export interface UserReferralData {
  statusCode: number;
  message: string;
  response?: string; // The referral link comes directly as a string
}

export const sendInviteEmailApi = async (email: string, lang: string = 'en-us'): Promise<InviteEmailData> => {
  const language = lang === 'sv-se' ? 'sv-se': 'en-us'
  try {
    // Send email as raw string (matching the curl request format)
    const response: InviteEmailData = await post(`/loyaltydashboard/email?lang=${language}`, `"${email}"`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUserReferralApi = async (lang:string): Promise<UserReferralData> => {
  try {
    const response: UserReferralData = await get(`/userreferral?lang=${lang}`);
    return response;
  } catch (error) {
    throw error;
  }
};
